<template>
  <PageTemplate>
    <Loader v-if="!isLoaded"/>
    <div v-else>
      <div class="element-box">
        <CoachingOverviewData :coaching="coachingData"/>
        <Menu :coaching="coachingData"
              :currentUser="piniaCurrentUser"/>

        <div class="d-flex justify-content-start mt-3">
          <div class="text-center pb-3 w-100" style="border-bottom: 1px solid #eee;">
            <h6 class="form-header mb-2">Teilnehmerbezogener Bericht</h6>

            <div class="d-flex flex-wrap justify-content-center">
              <div class="portal-export-item text-center" style="width: 100px; margin: 0 10px;">
                <a href="javascript:void(0)" class="btn portal_pdf_export w-100 d-flex flex-column align-items-center p-2"
                   @click="downloadFile(`/portal/private-coaching/participation-report-job-center-pdf/${coachingId}`, undefined)">
                  <img
                      src="../../../../../assets/img/pdf_icon_version4.png"
                      alt="PDF"
                      style="width: 45px; height: auto; object-fit: contain;"
                      class="mb-2"/>
                  <p class="small mb-0 text-dark font-weight-bold" style="line-height: 1.1;">Jobcenter</p>
                </a>
              </div>

              <div class="portal-export-item text-center" style="width: 100px; margin: 0 10px;">
                <a href="javascript:void(0)" class="btn portal_pdf_export w-100 d-flex flex-column align-items-center p-2"
                   @click="downloadFile(`/portal/private-coaching/participation-report-afa-pdf/${coachingId}`, undefined)">
                  <img
                      src="../../../../../assets/img/pdf_icon_version4.png"
                      alt="PDF"
                      style="width: 45px; height: auto; object-fit: contain;"
                      class="mb-2"/>
                  <p class="small mb-0 text-dark font-weight-bold" style="line-height: 1.1;">Afa</p>
                </a>
              </div>
            </div>
          </div>
        </div>

        <form @submit.prevent="submitForm" novalidate class="mt-4">
          <div class="row">
            <div class="col-lg-1"></div>
            <div class="col-lg-3 col-md-6 col-sm-12">
              <BaseCheckbox
                  v-model="formData.selectionInterview"
                  label="Auswahlgespräch"
                  :labelPosition="'right'"/>
              <BaseCheckbox
                  v-model="formData.houseRule"
                  label="Hausordnung"
                  :labelPosition="'right'"/>
              <BaseCheckbox
                  v-model="formData.trainingContract"
                  label="Weiterbildungsvertrag"
                  :labelPosition="'right'"/>
              <BaseCheckbox
                  v-model="formData.dataProtection"
                  label="Datenschutz"
                  :labelPosition="'right'"/>
              <BaseCheckbox
                  v-model="formData.healthQuestionnaire"
                  label="Gesundheitsfragebogen"
                  :labelPosition="'right'"/>
              <BaseCheckbox
                  v-model="formData.instruction"
                  label="Belehrung"
                  :labelPosition="'right'"/>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-12">
              <BaseToggle
                  v-model="formData.moreDocuments"
                  label="Unterschriftspflichtig"
                  @update:modelValue="onChangeMoreDocuments"/>
              <BaseCheckbox
                  v-model="formData.otherDocuments"
                  label="Abtretungserklärung"
                  :disabled="otherDocumentsDisabled"
                  :labelPosition="'right'"/>
            </div>

            <div class="col-lg-5 col-md-6 col-sm-12">
              <div class="row mt-3">
                <div class="col-lg-6 col-md-6 col-sm-12">
                  <BaseCheckbox
                      v-model="formData.finalReportSent"
                      label="Abschlussbericht versendet"
                      :labelPosition="'right'"
                      @update:modelValue="onChangeFinalReportSentCheckbox"/>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12">
                  <Datepicker
                      v-model="formData.finalReportSendingDate"
                      position="down"
                      :disabled="finalReportSendingDateDisabled"
                      :validation="v$?.finalReportSendingDate"
                      :messages="v$?.finalReportSendingDate?.required?.$message"/>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12">
                  <BaseCheckbox
                      v-model="formData.finalReportCreated"
                      label="Abschlussbericht erstellt"
                      :labelPosition="'right'"
                      @update:modelValue="onChangeFinalReportCreatedCheckbox"/>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12">
                  <Datepicker
                      v-model="formData.finalReportCreatedDate"
                      position="down"
                      :disabled="finalReportCreatedDateDisabled"
                      :validation="v$?.finalReportCreatedDate"
                      :messages="v$?.finalReportCreatedDate?.required?.$message"/>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-lg-1"></div>
            <div class="col-lg-6 col-md-12 col-sm-12">
              <span style="font-size: 16px; font-weight: bold;">BSG bekannt durch:</span>
              <BaseCheckbox
                  class="mt-2"
                  v-model="formData.clerk"
                  label="Sachbearbeiter"
                  :labelPosition="'right'"/>
              <BaseCheckbox
                  v-model="formData.courseNet"
                  label="Kursnet"
                  :labelPosition="'right'"/>
              <BaseCheckbox
                  v-model="formData.recommendationFromOtherParticipants"
                  label="Empfehlung von anderen Teilnehmen"
                  :labelPosition="'right'"/>
              <BaseCheckbox
                  v-model="formData.socialMedia"
                  label="Social Media"
                  :labelPosition="'right'"/>
              <BaseCheckbox
                  v-model="formData.others"
                  label="Sonstiges"
                  :labelPosition="'right'"
                  @update:modelValue="onChangeOthersCheckbox"/>
            </div>
          </div>
          <div class="row mt-1" v-if="formData.others">
            <div class="col-lg-1"></div>
            <div class="col-lg-6 col-md-12 col-sm-12">
              <BaseInput
                  v-model="formData.othersDescription"
                  :validation="v$?.othersDescription"
                  :messages="v$?.othersDescription?.required?.$message"/>
            </div>
          </div>

          <div class="form-buttons-w text-center">
            <SaveButton
                :label="$t('general.button.save')"
                :loading="isSubmitting"/>
          </div>
        </form>
      </div>
    </div>
  </PageTemplate>
</template>

<script setup>
import portalCoachingService from '@/api/Portal/PrivateCoaching';
import unemployedPrivateCoachingService from '@/api/Unemployed/PrivateCoaching';
import BaseCheckbox from '@/components/base/BaseCheckbox.vue';
import BaseInput from '@/components/base/BaseInput.vue';
import BaseToggle from '@/components/base/BaseToggle.vue';
import Loader from '@/components/Loader.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import Datepicker from '@/components/picker/Datepicker.vue';
import {CloseToast, ErrorToast, SuccessToast} from '@/components/VueToast';
import {requiredRule} from '@/shared/validators/validationRules';
import {piniaUserStore} from '@/store/piniaUserStore';
import CoachingOverviewData from '@/views/App/Portal/PrivateCoaching/CoachingOverviewData.vue';
import Menu from '@/views/App/Portal/PrivateCoaching/Menu.vue';
import useVuelidate from '@vuelidate/core';
import {computed, onMounted, ref} from 'vue';
import {useI18n} from 'vue-i18n';
import {useRoute} from 'vue-router';
import {downloadFile} from "@/shared/functions";
import SaveButton from '@/components/button/SaveButton.vue';

const piniaUserState = piniaUserStore();
const piniaCurrentUser = computed(() => piniaUserState?.currentUser?.user);
const {t} = useI18n();
const coachingData = ref(null);
const documentsId = ref(null);
const operationType = ref('');
const isDigitalSignature = ref(false);
const isSubmitting = ref(false);
const isLoaded = ref(false);
const finalReportSendingDateDisabled = ref(true);
const finalReportCreatedDateDisabled = ref(true);
const otherDocumentsDisabled = ref(true);
const route = useRoute();
const coachingId = +route.params.id;

const formData = ref({
  selectionInterview: false,
  houseRule: false,
  trainingContract: false,
  dataProtection: false,
  healthQuestionnaire: false,
  instruction: false,
  clerk: false,
  courseNet: false,
  recommendationFromOtherParticipants: false,
  socialMedia: false,
  others: false,
  othersDescription: '',

  finalReportSent: false,
  finalReportSendingDate: '',

  finalReportCreated: false,
  finalReportCreatedDate: '',

  moreDocuments: false,
  otherDocuments: false,
});

const rules = ref({});
const computedRules = computed(() => rules.value);
const v$ = useVuelidate(computedRules, formData);

async function submitForm() {
  v$.value.$touch();
  if (v$.value.$invalid) {
    return;
  }

  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {
    formData.value.coachingId = +coachingId;

    if (documentsId.value) {
      await portalCoachingService.putIntroductoryDocuments(formData.value, +documentsId.value);
    } else {
      await portalCoachingService.postIntroductoryDocuments(formData.value);
    }

    await getDocumentsData();
    isSubmitting.value = false;
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function getPrivateCoachingData() {
  try {
    CloseToast();
    const {data} = await unemployedPrivateCoachingService.getPrivateCoaching(+coachingId);

    coachingData.value = data.data;
    operationType.value = data?.data?.nameOfCoaching?.operationType;
    isDigitalSignature.value = data.data.digitalSignature;
  } catch (error) {
    await ErrorToast(error);
  }
}

async function getDocumentsData() {
  try {
    const {data} = await portalCoachingService.getIntroductoryDocumentsData(+coachingId);
    documentsId.value = data?.data?.id;
    if (documentsId.value) {
      formData.value = data.data;
    }
  } catch (error) {
    await ErrorToast(error);
  }
}

function onChangeOthersCheckbox(value) {
  formData.value.othersDescription = '';
  if (value === true) {
    rules.value = {
      ...rules.value,
      othersDescription: requiredRule(t),
    };
  } else {
    rules.value = {
      ...rules.value,
      othersDescription: '',
    };
  }
}



function onChangeFinalReportSentCheckbox(value) {
  formData.value.finalReportSendingDate = '';
  if (value === true) {
    finalReportSendingDateDisabled.value = false;
    rules.value = {
      ...rules.value,
      finalReportSendingDate: requiredRule(t),
    };
  } else {
    finalReportSendingDateDisabled.value = true;
    rules.value = {
      ...rules.value,
      finalReportSendingDate: '',
    };
  }
}

function onChangeFinalReportCreatedCheckbox(value) {
  formData.value.finalReportCreatedDate = '';
  if (value === true) {
    finalReportCreatedDateDisabled.value = false;
    rules.value = {
      ...rules.value,
      finalReportCreatedDate: requiredRule(t),
    };
  } else {
    finalReportCreatedDateDisabled.value = true;
    rules.value = {
      ...rules.value,
      finalReportCreatedDate: '',
    };
  }
}

function onChangeMoreDocuments(value) {
  formData.value.otherDocuments = false;
  if (value === true) {
    otherDocumentsDisabled.value = false;
  } else {
    otherDocumentsDisabled.value = true;
  }
}

onMounted(async () => {
  await Promise.all([
    getPrivateCoachingData(),
    getDocumentsData(),
  ]);

  isLoaded.value = true;
});

</script>

<style scoped>
</style>